import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { EntityMaster, EntityBackupDefinition } from './models/back/entity-backup-definition';
import { EntityQueryDefinitionsApiService } from '../api/entity-query-definitions-api.service';
import { EntityComputeDefinition, VeeamFilter, VmwareFilter } from './models/back/entity-compute-definition';

@Injectable({
    providedIn: 'root'
})
export class EntityQueryDefinitionsDomainService
{
    constructor (
        private queryDefinitionsApiService: EntityQueryDefinitionsApiService
    )
    {
    }

    getBackupDefinitions (entityId: string): Observable<EntityBackupDefinition>
    {
        return this.queryDefinitionsApiService.getBackupDefinitions(entityId)
            .pipe(
                map(EntityBackupDefinition.mapperFromApi)
            );
    }

    updateBackupDefinitions (entityId: string, BackupDefinitions: EntityMaster[]): Observable<EntityBackupDefinition>
    {
        return this.queryDefinitionsApiService.updateBackupDefinitions(entityId, BackupDefinitions)
            .pipe(
                map(EntityBackupDefinition.mapperFromApi)
            );
    }

    getComputeDefinition (entityId: string): Observable<EntityComputeDefinition>
    {
        return this.queryDefinitionsApiService.getComputeDefinition(entityId)
            .pipe(
                map(EntityComputeDefinition.mapperFromApi)
            );
    }

    updateVmwareDefinition (entityId: string, vmwareFilters: VmwareFilter[])
    {
        return this.queryDefinitionsApiService.updateWmwareDefinition(entityId, vmwareFilters)
            .pipe(
                map(EntityComputeDefinition.mapperFromApi)
            );
    }

    updateVeeamDefinition(entityId: string, veeamFilters: VeeamFilter[])
    {
        return this.queryDefinitionsApiService.updateVeeamDefinition(entityId, veeamFilters)
            .pipe(
                map(EntityComputeDefinition.mapperFromApi)
            );
    }
}
